import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';

const _ = {
  cloneDeep,
  isEqual,
};

/**
 * Class to help manage config values.
 */
class DependencyConfig {
  /**
   * Initializes a new field object with config and value.
   *
   * @param {Object} config - Unmutated dependency object.
   * @param {Object} fields - Field lookup object.
   */
  constructor(config = {}, fields = {}) {
    this.mutatedConfig = {};

    this.load(config, fields);
  }

  /**
   * Loads a new config.
   *
   * @param {Object} config - Dependency Object.
   * @param {Object} fields - Field lookup object.
   * @return {Field}
   */
  load(config = {}, fields = {}) {
    this.config = config;
    this.fields = fields;

    return this;
  }

  // TODO: This needs to handle deep nesting (write recursive reader)
  replaceValues(dataIndex = 0, isCollection = false) {
    const config = _.cloneDeep(this.config);

    // Find any field names and inject their values
    ['and', 'or'].forEach(condition => {
      // We have a condition with an array of experssions
      if (config[condition] && Array.isArray(config[condition])) {
        // Go through each expression
        config[condition].forEach(expression => {
          // Each expression is an object, whose key is an operator (==, !=)
          Object.keys(expression).forEach(operator => {
            // Each operator has an array of values to evaluate
            if (Array.isArray(expression[operator])) {
              // Loop through each value to see if the value actuallly matches a field name
              expression[operator].forEach((value, valueIndex) => {
                // The value is a field name
                if (this.fields[value]) {
                  // TODO: Oh boy the field gettings it's values updated is part of a collection so we
                  // want to maintain relativity when appropriate.  In order to make a smarter decision, we need
                  // to know which fields belong to the same collection and vice versa
                  if (isCollection && !(operator === 'in' && valueIndex > 0)) {
                    expression[operator][valueIndex] = this.fields[value].getValue(dataIndex);
                  } else {
                    expression[operator][valueIndex] = this.fields[value].getValue();
                  }
                }
              });
            }
          });
        });
      }
    });

    this.mutatedConfig = config;
  }

  getConfig() {
    return this.config;
  }

  getNewConfig() {
    return this.mutatedConfig;
  }

  isValid() {
    if (!this.config || _.isEqual({}, this.config)) {
      return false;
    }

    return true;
  }
}

export default DependencyConfig;
